(function (){
    'use strict';

    angular
        .module('services')
        .service('HowMuchService', HowMuchService);

    HowMuchService.$inject = ['$http', 'API_BASE'];

    function HowMuchService ($http, API_BASE) {
        var service = this;

        service.getAll = getAll;


        function getAll () {
            return $http.get(API_BASE + '/how_much/list');
        }

    }
})();